import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';

export const useInsightDetail = (reportType?: ReportType) => {
    const { currentAccount } = useAccountRepository();
    const [report, setReport] = useState<Report | null>(null);

    useEffect(() => {
        setReport(null);
        if (!currentAccount || !reportType) {
            return;
        }

        let cancelled = false;
        ReportClient.fetchReports({ type: reportType, account_id: currentAccount }).then((res) => {
            if (!cancelled) {
                setReport(res.results[0] ?? null);
            }
        });

        return () => {
            cancelled = true;
        };
    }, [currentAccount, reportType]);

    return {
        accountId: currentAccount,
        isReady: Boolean(currentAccount),
        report
    };
};
